import React from 'react';
import styled from 'styled-components';

const AnalyticsContainer = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
`;

const Title = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 1rem;
`;

const Bar = styled.div<{ width: number; color: string }>`
  height: 1.25rem;
  background-color: ${({ color }) => color};
  width: ${({ width }) => width}%;
  border-radius: 0.375rem;
  margin-bottom: 0.5rem;
`;

const mockAnalytics = [
  { label: 'Grade 4', value: 76, color: '#2563eb' },
  { label: 'Grade 7A', value: 78, color: '#059669' },
  { label: 'Grade 7B', value: 80, color: '#d97706' },
];

const PerformanceAnalytics: React.FC = () => (
  <AnalyticsContainer>
    <Title>Performance Analytics</Title>
    {mockAnalytics.map(a => (
      <div key={a.label} style={{ marginBottom: 8 }}>
        <div style={{ fontSize: '0.95em', color: '#374151', marginBottom: 2 }}>{a.label} ({a.value}%)</div>
        <Bar width={a.value} color={a.color} />
      </div>
    ))}
  </AnalyticsContainer>
);

export default PerformanceAnalytics; 